import React, { useEffect, useRef, useState } from "react";
import UserMessage from "./user/user_message.js";
import AiMessage from "./ai/ai_message.js";
import CourseRecommendations from "./course_recommendations/course_recommendations.js";
import StartCourseBtn from "../buttons/start_course_btn.js";
import CourseSelector from "./course_selector/course_selector.js";

function Messages({ messages, threeDots, host, startRecommendationOnclick, callbackFromCourseSelector, chatOnlyMode }) {
	const [showStartButton, setShowStartButton] = useState(() => {
		// Retrieve state from sessionStorage or default to true
		return sessionStorage.getItem("showStartButton") === "false" ? false : true;
	});

	const messagesEndRef = useRef(null);

	const scrollToBottom = () => {
		messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
	};

	const onClick = () => {
		setShowStartButton(false);
		sessionStorage.setItem("showStartButton", "false"); // Save state in sessionStorage
		startRecommendationOnclick();
	};

	useEffect(() => {
		if (chatOnlyMode) {
			setShowStartButton(false);
		}
	}, [chatOnlyMode]);

	useEffect(() => {
		const timer = setTimeout(scrollToBottom, 100);
		return () => clearTimeout(timer);
	}, [messages, threeDots]);

	return (
		<div className="messagesContainer">
			{messages.map((msg, index) => {
				if (chatOnlyMode && msg.isCourseSelector) {
					return null;
				}

				if (msg.isCourseSelector === true) {
					return <CourseSelector key={index} callbackFromCourseSelector={callbackFromCourseSelector} />;
				} else if (msg.isUser === true) {
					return <UserMessage key={index} message={msg.message} className="userMessage" />;
				} else if (msg.isUser === false) {
					return <AiMessage key={index} message={msg.message} threeDots={index === messages.length - 1 && threeDots} className="aiMessage" />;
				} else if (msg.isUser === null && msg.courseDetails) {
					return (
						<CourseRecommendations
							key={index}
							recommendation={msg.courseDetails}
							className="recommendations"
							host={host}
						/>
					);
				}
				return null;
			})}

			{showStartButton && !chatOnlyMode && <StartCourseBtn onClick={onClick} />}

			{/* Ref to ensure the last element is in view */}
			<div ref={messagesEndRef} />
		</div>
	);
}

export default Messages;
